import React from 'react'
import { Box } from 'react-bulma-components'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { useEmployerRuleQuery } from '../../queries/employer-rules'
import { EmployerRulesForm } from '../../components/employer-rules/employer-rules-form'
import useUrlId from '../../hooks/use-url-id'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'

/**
 * Component for managing employer rule details in settings
 * Uses outlet context to get employer and displays the form with sidebar
 */
const EmployerRuleDetailsSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const { id, isNew } = useUrlId({ idName: 'employerRuleId' })

  const { data: employerRule } = useEmployerRuleQuery(id, {
    enabled: Boolean(id && !isNew),
  })

  return (
    <>
      <SidebarContentTitle
        title={isNew ? 'Nouvelle Règle Employeur' : `Règle ${employerRule?.name || ''}`}
      />
      <Box>
        <EmployerRulesForm employerRule={employerRule} employerId={employer._id} />
      </Box>
    </>
  )
}

export default EmployerRuleDetailsSettings
